import { Box } from '@mui/material';
import {
  InsufficientAccessBackground,
  PlanSetsDetailSection,
  PlanSetsHeaderSection,
  useAccessState
} from 'modules';
import {
  Outlet,
  useParams
} from 'react-router-dom';


export const PlanSetsActivity = () => {
  const params = useParams();
  const access = useAccessState('PlanSet');

  if (params.planSetId) {
    return <Outlet />;
  }

  return access.view
    ? (
      <Box>
        <PlanSetsHeaderSection.FC />
        <PlanSetsDetailSection.FC />
      </Box>
    )
    : (
      <InsufficientAccessBackground.FC />
    );
};
